import { createFileRoute } from '@tanstack/react-router';
import { AdminClaimsPage } from '@/features/admin-claims';

export const Route = createFileRoute('/_authenticated/_admin/admin-claims')({
  component: AdminClaimsPage,
});
